// The FE has no internal-user marker, so the allowlist is the only client-side scoping
// available; the server's 403 is the real enforcement. Both halves must hold, and public
// routes render outside ProtectedRoute so they are excluded here.
// Its own module because ChatEntry has to answer "is chat on for this user?" *before* it
// dynamically imports the chat bundle — importing ChatDrawer to ask would defeat the split.

import { achTesterEligible } from '../../util/apiHostFor';
import { isPublicPath } from './pageContext';

export const agentChatEnabled = (params: {
  envFlag: string | undefined;
  userEmail: string | undefined | null;
  allowlistRaw: string | undefined | null;
  pathname: string;
}): boolean => {
  const { envFlag, userEmail, allowlistRaw, pathname } = params;
  return envFlag === 'true' && achTesterEligible(userEmail, allowlistRaw) && !isPublicPath(pathname);
};

export default agentChatEnabled;
